'use client';

import { ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';
import { Icon, IconsMap, getIconsSet, IconSetKeys } from '@nx-frontend/shared/ui/icon';
import { PortalIconSetName } from '@nx-frontend/shared/types';
import { IconKey } from '@nx-frontend/shared/types/icon';

interface ThemeIconProps extends ComponentPropsWithoutRef<'svg'> {
  name: string;
  themeIconSet?: PortalIconSetName;
  wrapperClassName?: string[];
}
export function ThemeIcon({ name, wrapperClassName, themeIconSet = 'default', ...props }: ThemeIconProps) {
  const IconSet = getIconsSet(themeIconSet);

  const IconComponent = Object.keys(IconSetKeys).includes(name)
    ? IconSet[name as keyof typeof IconSet]
    : Object.keys(IconsMap).includes(name)
    ? IconsMap[name as IconKey]
    : undefined;

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in theme "${IconSet}"`);
    return null;
  }

  return (
    <span className={classNames(wrapperClassName)}>
      <Icon icon={IconComponent} {...props} />
    </span>
  );
}
